import { isRGB } from './is-rgb';
import { isRGBA } from './is-rgba';

export function splitRGB (colorStr: string) {
  if (!isRGB(colorStr) && !isRGBA(colorStr)) {
    return [];
  }
  const exp = (isRGB(colorStr)) ? /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/ : /rgba\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/;
  const withoutSpaces = colorStr.replace(/\s/g, '');

  return exp.exec(withoutSpaces)?.slice(1) || [];
}
